import React from "react";
import { SplitScreen } from "../Template/ScreenRouter";
import {Product, Products} from "../Products";
import { PurchasePayment } from "../Purchase";
import { useSelector } from "react-redux";
import {getSelectedProduct, getSelectedProductId} from "../../reducers/products/selectors";
import {useMediaQuery} from "@material-ui/core";

function PurchasePaymentScreen() {
  const product = useSelector(getSelectedProduct);
  const products = useSelector(getSelectedProductId);
  if (!products) {
    return <></>;
  }

  return (
    <SplitScreen
      rightScreen={products.length === 1? <Product preview={true} product={product[0]} />: <Products/>}
      leftScreen={<PurchasePayment />}
    />
  );
}

export default PurchasePaymentScreen;
